import { QueryClient, QueryKey } from '@tanstack/react-query';

import { Message, MessageResponseBody } from '@liscio/api';

export type MessagesQueriesSnapshot = Array<
  [QueryKey, MessageResponseBody | undefined]
>;

export function mapMessagesCollections(
  data: MessageResponseBody,
  mapFn: (list: Array<Message> | undefined) => Array<Message> | undefined
): MessageResponseBody {
  return {
    ...data,
    inbox: mapFn(data.inbox) ?? data.inbox,
    sent: mapFn(data.sent) ?? data.sent,
    draft: mapFn(data.draft) ?? data.draft,
    archive: mapFn(data.archive) ?? data.archive,
    alert: mapFn(data.alert) ?? data.alert,
    pinned: mapFn(data.pinned) ?? data.pinned,
    all_messages: mapFn(data.all_messages) ?? data.all_messages,
  };
}

export async function applyOptimisticUpdateToMessages(
  client: QueryClient,
  transform: (data: MessageResponseBody) => MessageResponseBody
): Promise<MessagesQueriesSnapshot> {
  const previous = client.getQueriesData<MessageResponseBody>(['messages']);

  previous.forEach(([queryKey, data]) => {
    if (!data) return;
    const next = transform(data);
    client.setQueryData<MessageResponseBody>(queryKey, next);
  });

  return previous;
}

export function restoreMessages(
  client: QueryClient,
  snapshot?: MessagesQueriesSnapshot
): void {
  snapshot?.forEach(([queryKey, data]) => {
    client.setQueryData<MessageResponseBody>(queryKey, data);
  });
}
